import { ProjectRemindersComponent } from "@page/project-reminders/project-reminders.component";
import { UserSuggestionsComponent } from "@page/user-suggestions/user-suggestions.component";
import { AuthGuard } from "../helpers/auth.guard";
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { HomeComponent } from "src/pages/home/home.component";
import { AuthComponent } from "src/pages/auth/auth.component";
import { PublicProfileComponent } from "@page/public-profile/public-profile.component";
import { ProjectHistoricsComponent } from "@page/project-historics/project-historics.component";
import { MyStudentsComponent } from "@page/my-students/my-students.component";
import { StudentInstitutionGuard } from "@helpers/student-institution.guard";
import { InvitationsComponent } from "@page/invitations/invitations.component";
import { OverviewComponent } from "@page/overview/overview.component";
import { TextStructureCycleComponent } from "@page/text-structure-cycle/text-structure-cycle.component";
import { TranslationPageComponent } from "@page/translation-page/translation-page.component";
import { ManualPageComponent } from "@page/manuals/manual-page.component";
import { BasicOfMetodologyComponent } from "@page/basic-of-metodology/basic-of-metodology.component";
import { SubscriptionComponent } from "@page/subscription/subscription.component";
import { FirstWordsPlanComponent } from "@page/first-words-plan/first-words-plan.component";
import { SecondWordsPlanComponent } from "@page/second-words-plan/second-words-plan.component";
import { ExtractComponent } from "@component/extract/extract.component";
import { PaymentMethodComponent } from "@page/payment-method/payment-method.component";
import { CardComponent } from "@page/card/card.component";

const routes: Routes = [
  { path: "", component: HomeComponent, canActivate: [AuthGuard] },
  {
    path: "auth/:token/:paymentSessionCode",
    component: AuthComponent,
    pathMatch: "full",
  },
  { path: "unauthorized", component: AuthComponent },
  {
    path: "reminders",
    component: ProjectRemindersComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "suggestions",
    component: UserSuggestionsComponent,
    canActivate: [AuthGuard, StudentInstitutionGuard],
  },
  {
    path: "invitations",
    component: InvitationsComponent,
    canActivate: [AuthGuard, StudentInstitutionGuard],
  },
  {
    path: "translation-page",
    component: TranslationPageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "manual-page",
    component: ManualPageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "basic-of-metodology",
    component: BasicOfMetodologyComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "my-students",
    component: MyStudentsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "plans/first-words-plan",
    component: FirstWordsPlanComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "plans/second-words-plan",
    component: SecondWordsPlanComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "plans/pix",
    component: SubscriptionComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "plans/card",
    component: CardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "plans",
    loadChildren: "../pages/plans/plans.module#PlansModule",
    canActivate: [AuthGuard],
  },
  {
    path: "plans/payment-method",
    component: PaymentMethodComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "repositories",
    loadChildren:
      "../pages/repositories/repositories.module#RepositoriesModule",
    canActivate: [AuthGuard],
  },
  {
    path: "projects",
    loadChildren: "../pages/project/project.module#ProjectModule",
    canActivate: [AuthGuard],
  },
  {
    path: "admin",
    loadChildren: "../pages/admin/admin.module#AdminModule",
    canActivate: [AuthGuard],
  },
  {
    path: "institution",
    loadChildren: "../pages/institution/institution.module#InstitutionModule",
    canActivate: [AuthGuard],
  },
  {
    path: "projects/:id/historical",
    component: ProjectHistoricsComponent,
    canActivate: [AuthGuard, StudentInstitutionGuard],
  },
  {
    path: "projects/:id/overview",
    component: OverviewComponent,
    canActivate: [AuthGuard, StudentInstitutionGuard],
  },
  {
    path: "projects/:id/resources",
    component: TextStructureCycleComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "institution/advisors/:id/overview",
    component: OverviewComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "public/profile",
    component: PublicProfileComponent,
    canActivate: [AuthGuard, StudentInstitutionGuard],
  },
  { path: "extract", component: ExtractComponent, canActivate: [AuthGuard] },

  // otherwise redirect to home
  { path: "**", redirectTo: "" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
